import { getProductPageUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import {
    format,
    getPayloadObject,
    getTelemetryAttributes,
    ITelemetryContent,
    onTelemetryClick
} from '@msdyn365-commerce-modules/utilities';
import { PriceComponent, RatingComponent } from '@msdyn365-commerce/components';
import { IComponent, IComponentProps, ICoreContext, IGridSettings, IImageData, IImageSettings, Image } from '@msdyn365-commerce/core';
import { getCartState } from '@msdyn365-commerce/global-state';
import {
    // ProductAvailableQuantity,
    ProductPrice,
    ProductSearchResult
} from '@msdyn365-commerce/retail-proxy';
import { addCartLinesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { getEstimatedAvailabilityAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import * as React from 'react';
import { IPopupProps, Popup } from '../../utilities/popup';

export interface IProductComponentProps extends IComponentProps<{ product?: ProductSearchResult }> {
    className?: string;
    imageSettings?: IImageSettings;
    savingsText?: string;
    freePriceText?: string;
    originalPriceText?: string;
    currentPriceText?: string;
    ratingAriaLabel?: string;
    allowBack?: boolean;
    telemetryContent?: ITelemetryContent;
    dialogStrings?: {
        goToCartText: string;
        continueShoppingText: string;
        headerItemOneText: string;
        headerItemFormatText: string;
        headerMessageText: string;
        freePriceText: string;
        originalPriceText: string;
        currentPriceText: string;
    };
}

export interface IProductComponent extends IComponent<IProductComponentProps> {}

// tslint:disable-next-line:max-func-body-length
const ProductCard: React.FC<IProductComponentProps> = ({
    data,
    context,
    imageSettings,
    savingsText,
    freePriceText,
    originalPriceText,
    currentPriceText,
    ratingAriaLabel,
    allowBack,
    typeName,
    id,
    telemetryContent
}) => {
    const product = data.product;
    if (!product) {
        return null;
    }

    let productUrl = getProductPageUrlSync(product.Name || '', product.RecordId, context && context.actionContext, undefined);

    if (allowBack) {
        productUrl = updateProductUrl(productUrl, context);
    }

    // Construct telemetry attribute to render
    const payLoad = getPayloadObject('click', telemetryContent!, '', product.RecordId.toString());

    const attribute = getTelemetryAttributes(telemetryContent!, payLoad);

    const valuemin = 0;
    const valuemax = 1000;
    const valuenow = 0;

    // MODAL
    const [modalOpen, setModalOpen] = React.useState(false);

    // let productPrice;
    const popupProps: IPopupProps = {
        context: context,
        className: 'msc-add-to-pmcart',
        id: id,
        typeName: typeName,
        data: { product: product, price: product.Price },
        // @ts-ignore
        dialogStrings: {},
        imageSettings: imageSettings,
        gridSettings: context.request.gridSettings,
        productQuantity: 1,
        navigationUrl: '',
        modalOpen: modalOpen,
        setModalOpen: setModalOpen
    };

    const renderModalPopup = <Popup {...popupProps} />;

    const catPage = context.request.urlTokens.categories !== undefined ? context.request.urlTokens.categories[0] : '';
    const [available, setAvailable] = React.useState(true);
    const [availableLabel, setAvailableLabel] = React.useState('Available');
    const _isAvailable = async () => {
        await getEstimatedAvailabilityAsync(
            { callerContext: context.actionContext },
            { ProductIds: [product.RecordId], DefaultWarehouseOnly: true }
        )
            .then(productAvailabilites => {
                if (
                    productAvailabilites &&
                    productAvailabilites &&
                    productAvailabilites.ProductWarehouseInventoryAvailabilities &&
                    productAvailabilites.ProductWarehouseInventoryAvailabilities?.length > 0
                ) {
                    if (
                        product.Name !== 'Digital Gift Card' &&
                        productAvailabilites.ProductWarehouseInventoryAvailabilities[0].PhysicalAvailableInventoryLevelCode === 'OOS'
                    ) {
                        setAvailable(false);
                        setAvailableLabel(
                            productAvailabilites.ProductWarehouseInventoryAvailabilities[0].PhysicalAvailableInventoryLevelLabel ||
                                'OUT OF STOCK'
                        );
                    } else {
                        setAvailable(true);
                    }
                } else {
                    setAvailable(false);
                }
            })
            .catch(err => {
                console.error(err);
            });
        return;
    };

    React.useEffect(() => {
        void _isAvailable();
    }, [product]);

    if (catPage === 'pick-mix') {
        // @ts-ignore
        const searchContainerResaurces = context?.actionContext?.requestCache?.internalCache?.__MR['SEARCH-RESULT-CONTAINER']?.item;
        // @ts-ignore
        const pmProducts = context.pmProducts;
        const RecordId = product.RecordId;
        const initialQuntity = pmProducts && pmProducts[RecordId] && pmProducts[RecordId].Qty;
        const [add, setAdd] = React.useState(initialQuntity > 0 && initialQuntity !== undefined ? false : true);

        const [quantity, setQuantity] = React.useState(initialQuntity > 0 && initialQuntity !== undefined ? initialQuntity : 0);

        const removedFromCart = () => {
            const localPm = localStorage && localStorage.getItem('pm_products');
            const localPmProds = localPm && localPm !== null ? localPm : JSON.stringify({});
            const pmProductsList = JSON.parse(localPmProds);
            if (pmProductsList[product.RecordId] === undefined) {
                setQuantity(0);
                setAdd(true);
            }
        };
        const cookiePMset = typeof window !== 'undefined' ? localStorage.setItem('pm_products', JSON.stringify(pmProducts)) : undefined;
        React.useEffect(() => {
            const wrapper = document.getElementsByClassName('pm-cart--ctn')[0];

            // tslint:disable-next-line:typedef no-any
            function handleButtonClick(event: any) {
                const isButton = event.target.nodeName === 'BUTTON';

                if (!isButton) {
                    return;
                }
                const timer = setTimeout(() => {
                    removedFromCart();
                }, 100);
                return () => {
                    clearTimeout(timer);
                };
            }

            wrapper.addEventListener('click', handleButtonClick);
            return () => wrapper.removeEventListener('click', handleButtonClick);
        });

        function plusOneProductToPmCart(pRecordId: number): void {
            // @ts-ignore
            const pmProductsList = context.pmProducts;
            const productQuantity = Number(pmProductsList[pRecordId]?.Qty) + 1;
            if (pmProductsList[pRecordId] !== undefined) {
                pmProductsList[pRecordId].Qty = productQuantity;
                cookiePMset;
                setQuantity(productQuantity);
            } else {
                return;
            }
        }

        function removeOneProductFromPmCart(pRecordId: number): void {
            // @ts-ignore
            const pmProductsList = context.pmProducts;
            const productQuantity = Number(pmProductsList[pRecordId]?.Qty) - 1;

            if (productQuantity >= 0) {
                pmProductsList[pRecordId].Qty = productQuantity;
                cookiePMset;
                setQuantity(productQuantity);
            }
            if (productQuantity === 0) {
                delete pmProductsList[pRecordId];
                cookiePMset;
                setAdd(true);
            }
        }

        function addProductToPmCart(
            pRecordId: number,
            Name: string | undefined,
            Description: string | undefined,
            PrimaryImageUrl: string | undefined,
            pQuantity: number,
            Price: number
        ): void {
            // @ts-ignore
            const pmProductsList = context.pmProducts;
            setAdd(false);
            pmProductsList[pRecordId] = {
                Id: pRecordId,
                Item: Name,
                Qty: pQuantity,
                UOM: '',
                Price: Price,
                Description: Description,
                DataAreaId: '',
                PrimaryImageUrl: PrimaryImageUrl
            };
            // @ts-ignore
            context.pmProducts = pmProductsList;
            cookiePMset;
            setQuantity(1);
        }

        // @ts-ignore
        const AddToCartButtons = ({ showadd }) => {
            if (showadd) {
                return (
                    <>
                        {/* tslint:disable-next-line:jsx-no-lambda react-this-binding-issue */}
                        <button
                            className={'border-button add-to-mix-cart'}
                            onClick={() =>
                                addProductToPmCart(
                                    product.RecordId,
                                    product.Name,
                                    product.ItemId,
                                    product.PrimaryImageUrl,
                                    1,
                                    product.Price
                                )
                            }
                        >
                            {searchContainerResaurces.addText}
                        </button>
                    </>
                );
            }

            return (
                <>
                    {/* tslint:disable-next-line:jsx-no-lambda react-this-binding-issue */}
                    <button
                        onClick={() => removeOneProductFromPmCart(product.RecordId)}
                        title='Press to decrease the quantity by 1'
                        className='decrement quantity__controls'
                        aria-hidden='true'
                        aria-label='Press to decrease the quantity by 1'
                        color='secondary'
                    />
                    {/* tslint:disable-next-line:max-line-length */}
                    <input
                        type='number'
                        className='quantity-input'
                        pattern='[0-9]*'
                        value={quantity}
                        aria-live='polite'
                        aria-label='quantity input'
                        role='spinbutton'
                        aria-valuemin={valuemin}
                        aria-valuemax={valuemax}
                        aria-valuenow={valuenow}
                    />
                    {/* tslint:disable-next-line:jsx-no-lambda react-this-binding-issue max-line-length */}
                    <button
                        onClick={() => plusOneProductToPmCart(product.RecordId)}
                        title='Press to increment quantity by 1'
                        className='increment quantity__controls '
                        aria-hidden='true'
                        aria-label='Press to increment quantity by 1'
                        color='secondary'
                    />
                </>
            );
        };
        // @ts-ignore
        return (
            <div className={'msc-product__mix-item'}>
                <div className='msc-product__image'>
                    {renderProductPlacementImage(imageSettings, context.request.gridSettings, product.PrimaryImageUrl, product.Name)}
                </div>
                <div className='msc-product__details'>
                    <h4 className='msc-product__title'>{product.Name}</h4>
                    {renderModalPopup}
                    {/* tslint:disable-next-line:max-line-length jsx-no-lambda react-this-binding-issue react-a11y-event-has-role */}
                    {
                        <a
                            onClick={() => setModalOpen(true)}
                            aria-label={renderLabel(
                                product.Name,
                                context.cultureFormatter.formatCurrency(product.Price),
                                product.AverageRating,
                                ratingAriaLabel
                            )}
                            className='hyperlink view_details '
                            {...attribute}
                        >
                            {searchContainerResaurces.viewDetailsText}
                        </a>
                    }
                    {renderDescription(product.Description)}
                    {renderPrice(
                        context,
                        typeName,
                        id,
                        product.BasePrice,
                        product.Price,
                        savingsText,
                        freePriceText,
                        originalPriceText,
                        currentPriceText
                    )}

                    <div className='quantity'>
                        <AddToCartButtons showadd={add} />
                    </div>
                </div>
            </div>
        );
    } else {
        const _onAddSelectionToBag = async () => {
            const currentCartState = await getCartState(context?.actionContext);
            const cartLines = [
                {
                    ItemId: product.ItemId,
                    ProductId: product.RecordId,
                    Quantity: 1,
                    TrackingId: ''
                }
            ];
            return addCartLinesAsync(
                { callerContext: context.actionContext },
                currentCartState.cart.Id,
                cartLines,
                currentCartState.cart.Version!
            ).then(async res => {
                await currentCartState.refreshCart({}).then(() => {
                    // reload only for CartPage
                    if (window.location.pathname === context.app.routes.cart.destinationUrl) {
                        location.reload();
                    }
                });
            });
        };

        return (
            <>
                {/* tslint:disable-next-line:max-line-length */}
                <a
                    href={productUrl}
                    onClick={onTelemetryClick(telemetryContent!, payLoad, product.Name!)}
                    aria-label={renderLabel(
                        product.Name,
                        context.cultureFormatter.formatCurrency(product.Price),
                        product.AverageRating,
                        ratingAriaLabel
                    )}
                    className={`msc-product status_${available ? 'AVAL' : 'OOS'}`}
                    {...attribute}
                >
                    <div className='msc-product__image'>
                        {renderProductPlacementImage(imageSettings, context.request.gridSettings, product.PrimaryImageUrl, product.Name)}
                    </div>
                    <div className='msc-product__details'>
                        <h4 className='msc-product__title'>{product.Name}</h4>

                        {!available ? (
                            <div className='ms-buybox__inventory-info'>
                                <span className='ms-buybox__inventory-label ms-buybox__inventory-code-oos'>{availableLabel}</span>
                            </div>
                        ) : (
                            <div />
                        )}
                        {renderPrice(
                            context,
                            typeName,
                            id,
                            product.BasePrice,
                            product.Price,
                            savingsText,
                            freePriceText,
                            originalPriceText,
                            currentPriceText
                        )}
                        {renderDescription(product.Description)}
                        {!context.app.config.hideRating &&
                            renderRating(context, typeName, id, product.AverageRating, product.TotalRatings, ratingAriaLabel)}
                    </div>
                    <div className={'msc-product__extra-data'}>
                        <span className={'data-product-id'}>{product.RecordId}</span>
                        <span className={'data-product-sku'}>{product.ItemId}</span>
                    </div>
                </a>
                {available ? <button className={'solid-button msc-add-to-cart'} onClick={_onAddSelectionToBag} /> : ''}
            </>
        );
    }
};

function renderLabel(name?: string, price?: string, rating?: number, ratingAriaLabel?: string): string {
    name = name || '';
    price = price || '';
    return `${name} ${price} ${getRatingAriaLabel(rating, ratingAriaLabel)}`;
}

function renderDescription(description?: string): JSX.Element | null {
    return <p className='msc-product__text'>{description}</p>;
}

function getRatingAriaLabel(rating?: number, ratingAriaLabel?: string): string {
    if (rating && ratingAriaLabel) {
        const roundedRating = rating.toFixed(2);
        return format(ratingAriaLabel || '', roundedRating, '5');
    }
    return '';
}

function updateProductUrl(productUrl: string, context: ICoreContext): string {
    const srcUrl = new URL(productUrl, context.request.apiSettings.baseUrl);
    const queryString = `back=true`;
    if (srcUrl.search) {
        srcUrl.search += `&${queryString}`;
    } else {
        srcUrl.search += queryString;
    }

    const updatedUrl = new URL(srcUrl.href);
    return updatedUrl.pathname + srcUrl.search;
}

function renderRating(
    context: ICoreContext,
    typeName: string,
    id: string,
    avgRating?: number,
    totalRatings?: number,
    ariaLabel?: string
): JSX.Element | null {
    if (!avgRating) {
        return null;
    }

    const numRatings = (totalRatings && totalRatings.toString()) || undefined;
    const ratingAriaLabel = getRatingAriaLabel(avgRating, ariaLabel);

    return (
        <RatingComponent
            context={context}
            id={id}
            typeName={typeName}
            avgRating={avgRating}
            ratingCount={numRatings}
            readOnly={true}
            ariaLabel={ratingAriaLabel}
            data={{}}
        />
    );
}

function renderPrice(
    context: ICoreContext,
    typeName: string,
    id: string,
    basePrice?: number,
    adjustedPrice?: number,
    savingsText?: string,
    freePriceText?: string,
    originalPriceText?: string,
    currentPriceText?: string
): JSX.Element | null {
    const price: ProductPrice = {
        BasePrice: basePrice,
        AdjustedPrice: adjustedPrice,
        CustomerContextualPrice: adjustedPrice
    };

    return (
        <PriceComponent
            context={context}
            id={id}
            typeName={typeName}
            data={{ price: price }}
            savingsText={savingsText}
            freePriceText={freePriceText}
            originalPriceText={originalPriceText}
        />
    );
}

function renderProductPlacementImage(
    imageSettings?: IImageSettings,
    gridSettings?: IGridSettings,
    imageUrl?: string,
    altText?: string
): JSX.Element | null {
    if (!imageUrl || !gridSettings || !imageSettings) {
        return null;
    }
    const img: IImageData = {
        src: imageUrl,
        altText: altText ? altText : ''
    };
    const imageProps = {
        gridSettings: gridSettings,
        imageSettings: imageSettings
    };
    imageProps.imageSettings.cropFocalRegion = true;
    return <Image {...img} {...imageProps} loadFailureBehavior='empty' />;
}

// @ts-ignore
export default ProductCard;
